import React, { useEffect, useState } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button, Modal } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { FarmOperation_getMasters, TractorMasterAdd, TractorMastereGet, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { formatRoleName, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";

export const TractorMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [getLocation, setGetLocation] = useState([])
    const [name, setName] = useState()
    const [locationName, setLocationName] = useState()
    const [locationId, setLocationId] = useState()
    const [status, setStatus] = useState()
    const [regNo, setRegNo] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [regNoError, setRegNoError] = useState('')
    const [locationError, setLocationError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)

    const getData = async () => {
        const URL = TractorMastereGet;
        try {
            setLoader(true)
            const headers = await GetApiHeaders();
            const response = await axios.get(URL, { headers })
            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    const LocationDropdown = async () => {
        const apiUrl = FarmOperation_getMasters;
        const headers = await GetApiHeaders();
        try {
            const response = await axios.get(apiUrl, { headers })
            setGetLocation(response.data.response.subSiteMaster)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getData()
        LocationDropdown()
    }, [])

    const headersData = [
        {
            field: "name",
            header: "Tractor Name",
        },
        {
            field: "locationid.name",
            header: "Location Name",
        },
        {
            field: "registrationNo",
            header: "Registration Number",
        },

        {
            field: "status",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        console.log(data, "dataaa");
        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setName(data.name)
        setLocationName(data.locationid.name)
        setLocationId(data.locationid.id)
        setStatus(data.active)
        setRegNo(data.registrationNo)
        setError('')
        setLocationError('')
        setStatusError('')
        setRegNoError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setLocationName('')
        setRegNo('')
        setStatus('')
        setLocationId('')
        setError('')
        setLocationError('')
        setStatusError('')
        setRegNoError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const handleName = (e) => {
        const Input = e.target.value
        const formattedInput = formatRoleName(Input);
        setName(formattedInput)
        if (Input) {
            setError('')
        }
    }

    const handleLocation = (e) => {
        const locationInput = e.target.value
        setLocationName(locationInput)
        const locationsID = e.target.options[e.target.selectedIndex].getAttribute("data-locationId");
        setLocationId(locationsID)
        if (locationInput) {
            setLocationError('')
        }
    }

    const handleStatus = (e) => {
        const statusInput = e.target.value;
        setStatus(statusInput);
        if (statusInput !== null && statusInput !== undefined && statusInput !== "") {
            setStatusError("");
        }
    };

    const handleRegNo = (e) => {
        const Input = e.target.value
        const upperCaseInput = Input.toUpperCase();
        setRegNo(upperCaseInput)
        if (Input) {
            setRegNoError('')
        }
    }

    const handleSubmitData = async () => {
        const apiUrl = TractorMasterAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            name: name,
            locationId: parseInt(locationId),
            locationName: locationName,
            registrationNo: regNo,
            status: status
        }
        const headers = await GetApiHeaders()
        try {
            if (!status) {
                setStatusError("Select Status")
            }
            if (!locationName) {
                setLocationError('Select Location')
            }
            if (!name) {
                setError('Enter Tractor Name')
            }
            if (!regNo) {
                setRegNoError('Enter Registration No')
            }
            if (name !== '' && locationName !== '' && regNo !== '' && status !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }

        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">  Master</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> Tractor Master</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Add Tractor Master"  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <FontAwesomeIcon icon={faPlus} className="plus_icon mr-1" />
                                                    Add
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                            FileName={'Tractor'}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Tractor Master'}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12 mt-2'>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Tractor  Name <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Tractor Name' value={name} onChange={handleName} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {error}</span>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="InputName"
                                                                className="form-label text-sm font-weight-600 " style={{ marginTop: "14px" }}
                                                            >
                                                                Location <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="dropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Location Name"
                                                                value={
                                                                    getLocation
                                                                        .map((item) => ({
                                                                            value: item.name,
                                                                            label: item.name,
                                                                            locationId: item.code,
                                                                        }))
                                                                        .find((option) => option.value === locationName) || null
                                                                }
                                                                options={getLocation.map((item) => ({
                                                                    value: item.name,
                                                                    label: item.name,
                                                                    locationId: item.code,
                                                                }))}
                                                                onChange={(selectedOption) =>
                                                                    handleLocation({
                                                                        target: {
                                                                            value: selectedOption?.value || "",
                                                                            options: [
                                                                                {
                                                                                    getAttribute: (attr) =>
                                                                                        attr === "data-locationId"
                                                                                            ? selectedOption?.locationId
                                                                                            : "",
                                                                                },
                                                                            ],
                                                                            selectedIndex: 0,
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />

                                                            <span style={{ color: "red" }}>{locationError}</span>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12 mt-2'>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                Registration No <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " placeholder='Enter Registration No' value={regNo} onChange={handleRegNo} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {regNoError}</span>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="InputName"
                                                                className="form-label text-sm font-weight-600 " style={{ marginTop: "14px" }}
                                                            >
                                                                Status <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="dropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder="Select Status"
                                                                value={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ].find(
                                                                    (option) => String(option.value) === String(status)
                                                                ) || null}
                                                                options={[
                                                                    { value: true, label: "Active" },
                                                                    { value: false, label: "In-Active" },
                                                                ]}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                                isClearable
                                                            />
                                                            <span style={{ color: "red" }}> {statusError}</span>

                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={'Tractor Master'}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}